import Message from "./Message";

export default class TVApp {
    app?: { id: number, label: string };
    hasInfoMessage = false;
    message = new Message();
    data: string = '';
}
